<template>
	<div class="solarContainer">
		<p class="text1">Автономное электроснабжение объектов нефтегазовой промышленности</p>
		<p class="text2">Сельское хозяйство</p>
		<p class="text3">Метеостанции</p>
		<p class="text4">Сотовые операторы</p>

		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			 height="80" viewBox="0 0 59.64 52.69" style="enable-background:new 0 0 59.64 52.69;" xml:space="preserve" class="icon1">
			<defs>
</defs>
			<g id="surface1_1_">
	<path class="st0" d="M29.82,25.84c-5.49,0-9.94,4.45-9.94,9.94c0,5.49,4.45,9.94,9.94,9.94s9.94-4.45,9.94-9.94
		C39.75,30.3,35.31,25.85,29.82,25.84z M29.82,43.74c-4.39,0-7.95-3.56-7.95-7.95s3.56-7.95,7.95-7.95s7.95,3.56,7.95,7.95
		C37.77,40.17,34.21,43.73,29.82,43.74z"/>
				<path class="st0" d="M29.82,24.85c0.55,0,0.99-0.44,0.99-0.99v-0.99c0-0.55-0.45-0.99-0.99-0.99s-0.99,0.45-0.99,0.99v0.99
		C28.83,24.41,29.27,24.85,29.82,24.85z"/>
				<path class="st0" d="M38.25,25.94l-0.7,0.7c-0.39,0.38-0.41,1.01-0.02,1.41c0.38,0.39,1.01,0.41,1.41,0.02
		c0.01-0.01,0.02-0.02,0.02-0.02l0.7-0.7c0.38-0.39,0.37-1.02-0.02-1.41C39.25,25.57,38.64,25.57,38.25,25.94z"/>
				<path class="st0" d="M42.74,34.79h-0.99c-0.55,0-0.99,0.45-0.99,0.99s0.44,0.99,0.99,0.99h0.99c0.55,0,0.99-0.45,0.99-0.99
		S43.29,34.79,42.74,34.79z"/>
				<path class="st0" d="M38.96,43.52c-0.39-0.38-1.02-0.37-1.41,0.02c-0.37,0.39-0.37,1,0,1.38l0.7,0.7c0.39,0.39,1.02,0.39,1.41,0
		c0.39-0.39,0.39-1.02,0-1.41L38.96,43.52z"/>
				<path class="st0" d="M29.82,46.72c-0.55,0-0.99,0.45-0.99,0.99v0.99c0,0.55,0.45,0.99,0.99,0.99s0.99-0.45,0.99-0.99v-0.99
		C30.81,47.16,30.37,46.72,29.82,46.72z"/>
				<path class="st0" d="M20.68,43.52l-0.7,0.7c-0.39,0.39-0.39,1.02,0,1.41c0.39,0.39,1.02,0.39,1.41,0l0.7-0.7
		c0.38-0.39,0.37-1.02-0.02-1.41C21.68,43.14,21.07,43.14,20.68,43.52L20.68,43.52z"/>
				<path class="st0" d="M17.89,34.79H16.9c-0.55,0-0.99,0.45-0.99,0.99s0.44,0.99,0.99,0.99h0.99c0.55,0,0.99-0.45,0.99-0.99
		S18.44,34.79,17.89,34.79z"/>
				<path class="st0" d="M20.68,28.05c0.39,0.38,1.02,0.37,1.41-0.02c0.37-0.39,0.37-1,0-1.38l-0.7-0.7c-0.39-0.39-1.02-0.39-1.41,0
		c-0.39,0.39-0.39,1.02,0,1.41L20.68,28.05z"/>
				<path class="st0" d="M56.66,24.85c-1.65,0-2.98,1.34-2.98,2.98v0.99H45.2c-1.7-3.73-4.69-6.72-8.42-8.42v-7.48
		c0-0.55-0.45-0.99-0.99-0.99H33.8V5.96h11.93c1.65,0,2.98-1.34,2.98-2.98S47.37,0,45.72,0H13.92c-1.65,0-2.98,1.34-2.98,2.98
		s1.33,2.98,2.98,2.98h11.93v5.96h-1.99c-0.55,0-0.99,0.45-0.99,0.99v7.48c-3.73,1.7-6.72,4.69-8.42,8.42H5.96v-0.99
		c0-1.65-1.34-2.98-2.98-2.98S0,26.19,0,27.83v15.9c0,1.65,1.34,2.98,2.98,2.98s2.98-1.33,2.98-2.98v-0.99h8.48
		c3.83,8.49,13.82,12.28,22.31,8.45c3.75-1.69,6.76-4.7,8.45-8.45h8.48v0.99c0,1.65,1.34,2.98,2.98,2.98s2.98-1.33,2.98-2.98v-15.9
		C59.64,26.19,58.31,24.85,56.66,24.85z M12.92,2.98c0-0.55,0.44-0.99,0.99-0.99h31.81c0.55,0,0.99,0.45,0.99,0.99
		s-0.44,0.99-0.99,0.99H13.92C13.37,3.98,12.92,3.53,12.92,2.98z M27.83,5.96h3.98v5.96h-3.98V5.96z M24.85,13.92h9.94v5.72
		c-3.24-1-6.7-1-9.94,0V13.92z M3.98,43.74c0,0.55-0.44,0.99-0.99,0.99s-0.99-0.44-0.99-0.99v-15.9c0-0.55,0.45-0.99,0.99-0.99
		s0.99,0.44,0.99,0.99V43.74z M5.96,40.75v-9.94h7.71c-1,3.24-1,6.7,0,9.94H5.96z M29.82,50.69c-8.23,0-14.91-6.68-14.91-14.91
		c0-8.23,6.68-14.91,14.91-14.91s14.91,6.68,14.91,14.91C44.72,44.02,38.05,50.69,29.82,50.69z M45.97,40.75c1-3.24,1-6.7,0-9.94
		h7.71v9.94H45.97z M57.65,43.74c0,0.55-0.45,0.99-0.99,0.99s-0.99-0.44-0.99-0.99v-15.9c0-0.55,0.44-0.99,0.99-0.99
		s0.99,0.44,0.99,0.99V43.74z"/>
</g>
</svg>

		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			 height="80" viewBox="0 0 52.47 62.56" style="enable-background:new 0 0 52.47 62.56;" xml:space="preserve" class="icon2">
			<defs>
</defs>
			<g>
	<path class="st0" d="M52.18,41.57L35.36,24.76c-0.19-0.19-0.45-0.3-0.72-0.3s-0.53,0.11-0.72,0.3l-2.29,2.29c0,0,0,0,0,0
		c0,0,0,0,0,0l-1.58,1.58l-2.39-2.39l3.11-3.11L47.59,6.32c0.4-0.4,0.4-1.04,0-1.43L43,0.3C42.81,0.11,42.56,0,42.29,0
		s-0.53,0.11-0.72,0.3L24.76,17.11c-0.19,0.19-0.3,0.45-0.3,0.72c0,0.27,0.11,0.53,0.3,0.72l2.29,2.29c0,0,0,0,0,0c0,0,0,0,0,0
		l1.58,1.58l-2.39,2.39l-3.11-3.11L6.32,4.88c-0.4-0.4-1.04-0.4-1.43,0L0.3,9.47C0.11,9.66,0,9.92,0,10.19
		c0,0.27,0.11,0.53,0.3,0.72l16.82,16.82c0.19,0.19,0.45,0.3,0.72,0.3c0.27,0,0.53-0.11,0.72-0.3l3.87-3.87l2.39,2.39l-3.11,3.11
		L4.88,46.16c-0.4,0.4-0.4,1.04,0,1.43l4.59,4.59c0.19,0.19,0.45,0.3,0.72,0.3s0.53-0.11,0.72-0.3l5.99-5.99l-1.38,7.62
		c-0.05,0.3,0.03,0.6,0.22,0.83c0.19,0.23,0.48,0.36,0.78,0.36h0.07v5.54h-2.23c-0.56,0-1.01,0.45-1.01,1.01
		c0,0.56,0.45,1.01,1.01,1.01h23.78c0.56,0,1.01-0.45,1.01-1.01c0-0.56-0.45-1.01-1.01-1.01H35.9v-5.54h0.07
		c0.3,0,0.59-0.13,0.78-0.36c0.19-0.23,0.27-0.53,0.22-0.83l-3.42-18.83l12.62,12.62c0.2,0.2,0.46,0.3,0.72,0.3
		c0.26,0,0.52-0.1,0.72-0.3L52.18,43c0.19-0.19,0.3-0.45,0.3-0.72C52.47,42.02,52.37,41.76,52.18,41.57z M42.29,2.45l3.15,3.15
		L30.06,20.98l-0.86-0.86l6.93-6.93c0.4-0.4,0.4-1.04,0-1.43c-0.4-0.4-1.04-0.4-1.43,0l-6.93,6.93l-0.86-0.86L42.29,2.45z
		 M17.83,25.57L2.45,10.19L5.6,7.03l15.38,15.38l-0.86,0.86l-6.93-6.93c-0.4-0.4-1.04-0.4-1.43,0c-0.4,0.4-0.4,1.04,0,1.43
		l6.93,6.93L17.83,25.57z M10.19,50.03l-3.15-3.15l15.38-15.38l0.86,0.86l-6.93,6.93c-0.4,0.4-0.4,1.04,0,1.43
		c0.2,0.2,0.46,0.3,0.72,0.3c0.26,0,0.52-0.1,0.72-0.3l6.93-6.93l0.86,0.86L10.19,50.03z M33.87,60.53h-6.62v-3.31
		c0-0.56-0.45-1.01-1.01-1.01c-0.56,0-1.01,0.45-1.01,1.01v3.31H18.6v-5.54h15.27V60.53z M34.75,52.97H17.72l1.69-9.3l8.3-8.3
		c0.19-0.19,0.3-0.45,0.3-0.72s-0.11-0.53-0.3-0.72l-3.87-3.87l2.39-2.39l3.11,3.11l1.68,1.68L34.75,52.97z M46.87,45.44
		L31.49,30.06l0.86-0.86l6.93,6.93c0.2,0.2,0.46,0.3,0.72,0.3c0.26,0,0.52-0.1,0.72-0.3c0.4-0.4,0.4-1.04,0-1.43l-6.93-6.93
		l0.86-0.86l15.38,15.38L46.87,45.44z"/>
				<path class="st0" d="M21.91,59.32c0.56,0,1.01-0.45,1.01-1.01v-1.08c0-0.56-0.45-1.01-1.01-1.01s-1.01,0.45-1.01,1.01v1.08
		C20.9,58.86,21.35,59.32,21.91,59.32z"/>
				<path class="st0" d="M30.56,59.32c0.56,0,1.01-0.45,1.01-1.01v-1.08c0-0.56-0.45-1.01-1.01-1.01c-0.56,0-1.01,0.45-1.01,1.01v1.08
		C29.55,58.86,30,59.32,30.56,59.32z"/>
				<path class="st0" d="M26.24,41.08c-0.56,0-1.01,0.45-1.01,1.01v1.08c0,0.56,0.45,1.01,1.01,1.01c0.56,0,1.01-0.45,1.01-1.01v-1.08
		C27.25,41.53,26.8,41.08,26.24,41.08z"/>
</g>
</svg>

		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			 height="80" viewBox="0 0 54.25 52.38" style="enable-background:new 0 0 54.25 52.38;" xml:space="preserve" class="icon3">
			<defs>
</defs>
			<path class="st0" d="M50.7,10.48L17.69,6.17c-0.17-0.04-0.34-0.06-0.51-0.06c-0.88,0-1.62,0.51-2.25,1.35l-9.5,6.55V8.64
	c2.06-0.41,3.62-2.17,3.62-4.28C9.04,1.96,7.01,0,4.52,0S0,1.96,0,4.37c0,2.11,1.56,3.87,3.62,4.28v33.26H1.81v5.24H0v5.24h9.04
	v-5.24H7.23v-5.24H5.43V17.82l8.86,8.55c0.73,1.49,1.69,2.43,2.9,2.43c0.18,0,0.35-0.02,0.51-0.06l33.01-4.31
	c1.36-0.03,3.55-1,3.55-6.98S52.06,10.51,50.7,10.48z M7.23,50.64H1.81v-1.75h5.43V50.64z M3.62,47.15v-3.49h1.81v3.49H3.62z
	 M45.21,17.46c0,2.19-0.26,4.3-0.71,6.04l-3.67,0.48c0.49-1.88,0.76-4.14,0.76-6.52c0-2.38-0.27-4.63-0.76-6.51l3.67,0.48
	C44.96,13.17,45.21,15.27,45.21,17.46z M39.78,17.46c0,2.51-0.33,4.93-0.9,6.77l-3.69,0.48c0.62-1.99,0.98-4.54,0.98-7.25
	c0-2.7-0.35-5.25-0.97-7.25l3.69,0.48C39.46,12.53,39.78,14.96,39.78,17.46z M19.87,18.57c0,0.12-0.01,0.23-0.02,0.35
	c-0.01,0.23-0.02,0.47-0.04,0.69c-0.01,0.13-0.02,0.26-0.03,0.39c-0.02,0.2-0.03,0.4-0.05,0.59c-0.01,0.14-0.03,0.26-0.05,0.39
	c-0.02,0.17-0.04,0.35-0.07,0.52c-0.02,0.13-0.04,0.25-0.06,0.38c-0.03,0.16-0.05,0.32-0.08,0.47c-0.02,0.12-0.05,0.24-0.07,0.36
	c-0.03,0.14-0.06,0.29-0.09,0.42c-0.03,0.11-0.05,0.22-0.08,0.33c-0.03,0.13-0.07,0.26-0.1,0.38c-0.03,0.1-0.06,0.2-0.09,0.3
	c-0.04,0.12-0.07,0.23-0.11,0.34c-0.03,0.09-0.06,0.18-0.09,0.27c-0.04,0.1-0.08,0.2-0.11,0.3c-0.03,0.08-0.07,0.16-0.1,0.24
	c-0.04,0.09-0.08,0.18-0.12,0.26c-0.03,0.07-0.07,0.14-0.1,0.21c-0.04,0.08-0.08,0.15-0.12,0.22c-0.03,0.06-0.07,0.12-0.1,0.18
	c-0.04,0.07-0.08,0.13-0.12,0.19c-0.03,0.05-0.07,0.1-0.1,0.14c-0.04,0.06-0.08,0.1-0.12,0.15c-0.03,0.04-0.06,0.07-0.09,0.11
	c-0.04,0.04-0.08,0.08-0.12,0.11c-0.03,0.02-0.06,0.05-0.08,0.07c-0.03,0.02-0.06,0.03-0.08,0.05l-1.68-1.62
	c-0.7-1.59-1.31-4.25-1.31-7.89c0-4.39,0.9-7.37,1.75-8.74l1.17-0.81c0.01,0.01,0.02,0.01,0.04,0.02C17.46,7.95,17.5,7.97,17.54,8
	c0.03,0.02,0.06,0.05,0.08,0.07c0.04,0.03,0.08,0.07,0.12,0.11c0.03,0.03,0.06,0.07,0.09,0.11c0.04,0.05,0.08,0.1,0.12,0.15
	c0.03,0.04,0.07,0.09,0.1,0.14c0.04,0.06,0.08,0.12,0.12,0.19c0.03,0.06,0.07,0.12,0.1,0.18c0.04,0.07,0.08,0.15,0.12,0.22
	c0.03,0.07,0.07,0.14,0.1,0.21c0.04,0.08,0.08,0.17,0.12,0.26c0.03,0.08,0.07,0.16,0.1,0.24c0.04,0.1,0.08,0.2,0.11,0.3
	c0.03,0.09,0.06,0.18,0.09,0.27c0.04,0.11,0.07,0.22,0.11,0.34c0.03,0.1,0.06,0.2,0.09,0.3c0.03,0.12,0.07,0.25,0.1,0.38
	c0.03,0.11,0.06,0.22,0.08,0.33c0.03,0.14,0.06,0.28,0.09,0.42c0.02,0.12,0.05,0.23,0.07,0.36c0.03,0.15,0.06,0.31,0.08,0.47
	c0.02,0.13,0.04,0.25,0.06,0.38c0.02,0.17,0.05,0.34,0.07,0.52c0.02,0.13,0.03,0.26,0.05,0.39c0.02,0.19,0.04,0.39,0.05,0.59
	c0.01,0.13,0.02,0.26,0.03,0.39c0.02,0.22,0.03,0.46,0.04,0.69c0.01,0.12,0.01,0.23,0.02,0.35c0.01,0.36,0.02,0.72,0.02,1.1
	S19.89,18.21,19.87,18.57z M1.81,4.37c0-1.44,1.22-2.62,2.71-2.62s2.71,1.18,2.71,2.62S6.02,6.98,4.52,6.98S1.81,5.81,1.81,4.37z
	 M5.92,15.83l7.6-5.24c-0.57,2-0.86,4.44-0.86,6.88c0,1.85,0.17,3.7,0.5,5.36L5.92,15.83z M19.95,26.63
	c0.12-0.23,0.24-0.47,0.34-0.72c0.04-0.09,0.08-0.19,0.11-0.29c0.08-0.2,0.15-0.41,0.23-0.62c0.04-0.11,0.07-0.22,0.11-0.33
	c0.07-0.23,0.13-0.46,0.2-0.7c0.03-0.1,0.06-0.2,0.08-0.31c0.08-0.35,0.16-0.7,0.23-1.07c0,0,0-0.01,0-0.01
	c0.07-0.36,0.13-0.74,0.18-1.11c0.02-0.12,0.03-0.24,0.04-0.36c0.03-0.27,0.06-0.54,0.09-0.82c0.01-0.14,0.02-0.27,0.04-0.41
	c0.02-0.28,0.04-0.56,0.05-0.84c0.01-0.12,0.01-0.25,0.02-0.37c0.02-0.4,0.03-0.81,0.03-1.21s-0.01-0.8-0.03-1.21
	c0-0.12-0.01-0.25-0.02-0.37c-0.01-0.28-0.03-0.56-0.05-0.84c-0.01-0.14-0.02-0.27-0.04-0.41c-0.03-0.28-0.06-0.55-0.09-0.82
	c-0.01-0.12-0.03-0.24-0.04-0.36c-0.05-0.38-0.11-0.75-0.18-1.11c0,0,0-0.01,0-0.01c-0.07-0.37-0.15-0.72-0.23-1.07
	c-0.03-0.11-0.05-0.21-0.08-0.31c-0.06-0.24-0.13-0.47-0.2-0.7c-0.04-0.11-0.07-0.22-0.11-0.33c-0.07-0.21-0.15-0.42-0.23-0.62
	c-0.04-0.1-0.07-0.19-0.11-0.29c-0.11-0.25-0.22-0.5-0.34-0.72c-0.01-0.02-0.02-0.05-0.03-0.07L33.2,9.96
	c0.73,1.88,1.16,4.63,1.16,7.5c0,2.88-0.43,5.63-1.16,7.51L19.92,26.7C19.93,26.68,19.94,26.65,19.95,26.63z M50.64,22.7l-4.21,0.55
	c0.38-1.73,0.59-3.73,0.59-5.79c0-2.05-0.21-4.05-0.59-5.78l4.09,0.53l0.12,0.01c0.83,0,1.81,1.37,1.81,5.24S51.47,22.7,50.64,22.7z
	"/>
</svg>

		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			 height="80" viewBox="0 0 29.23 52.38" style="enable-background:new 0 0 29.23 52.38;" xml:space="preserve" class="icon4">
			<defs>
</defs>
			<g>
	<g>
		<path class="st0" d="M27.18,51.07l-4.26-14.12c0,0,0,0,0,0l-1.52-5.04c0,0,0,0,0,0l-2.1-6.96c0,0,0,0,0,0l-3.34-11.07
			c1.47-0.53,2.52-1.91,2.52-3.52c0-2.07-1.73-3.76-3.86-3.76s-3.86,1.69-3.86,3.76c0,1.61,1.05,2.99,2.52,3.52L6.31,36.95
			c0,0,0,0,0,0L2.05,51.07c-0.16,0.54,0.16,1.12,0.72,1.28c0.56,0.16,1.15-0.15,1.31-0.7l0.65-2.15l9.89-6.35l9.89,6.35l0.65,2.15
			c0.14,0.45,0.56,0.74,1.01,0.74c0.1,0,0.2-0.01,0.3-0.04C27.03,52.18,27.35,51.61,27.18,51.07z M12.87,10.35
			c0-0.94,0.78-1.7,1.75-1.7s1.75,0.76,1.75,1.7s-0.78,1.7-1.75,1.7S12.87,11.29,12.87,10.35z M14.62,16.73l2.26,7.5h-4.52
			L14.62,16.73z M11.73,26.28h5.77l1.48,4.91h-8.73L11.73,26.28z M5.65,46.44l2.29-7.58l4.76,3.06L5.65,46.44z M8.56,36.8l1.07-3.55
			h9.97l1.07,3.55l-6.06,3.89L8.56,36.8z M16.53,41.92l4.76-3.06l2.29,7.58L16.53,41.92z"/>
	</g>
</g>
			<g>
	<g>
		<path class="st0" d="M9.59,5.46c0.41-0.4,0.41-1.05,0-1.45c-0.41-0.4-1.08-0.4-1.5,0c-3.6,3.5-3.6,9.19,0,12.68
			c0.21,0.2,0.48,0.3,0.75,0.3c0.27,0,0.54-0.1,0.75-0.3c0.41-0.4,0.41-1.05,0-1.45C6.82,12.54,6.82,8.16,9.59,5.46z"/>
	</g>
</g>
			<g>
	<g>
		<path class="st0" d="M21.14,4.01c-0.41-0.4-1.08-0.4-1.5,0c-0.41,0.4-0.41,1.05,0,1.45c2.77,2.69,2.77,7.08,0,9.77
			c-0.41,0.4-0.41,1.05,0,1.45c0.21,0.2,0.48,0.3,0.75,0.3c0.27,0,0.54-0.1,0.75-0.3C24.74,13.19,24.74,7.5,21.14,4.01z"/>
	</g>
</g>
			<g>
	<g>
		<path class="st0" d="M5.78,1.75c0.41-0.4,0.41-1.05,0-1.45c-0.41-0.4-1.08-0.4-1.5,0C1.52,2.98,0,6.55,0,10.35
			c0,3.8,1.52,7.36,4.28,10.05c0.21,0.2,0.48,0.3,0.75,0.3c0.27,0,0.54-0.1,0.75-0.3c0.41-0.4,0.41-1.05,0-1.45
			C0.9,14.2,0.9,6.49,5.78,1.75z"/>
	</g>
</g>
			<g>
	<g>
		<path class="st0" d="M27.07,2.9c-0.31-0.48-0.96-0.63-1.46-0.34c-0.5,0.3-0.65,0.93-0.35,1.41c3.05,4.81,2.3,10.96-1.81,14.96
			c-0.41,0.4-0.41,1.05,0,1.45c0.21,0.2,0.48,0.3,0.75,0.3c0.27,0,0.54-0.1,0.75-0.3c2.34-2.27,3.83-5.28,4.19-8.47
			C29.5,8.78,28.76,5.58,27.07,2.9z"/>
	</g>
</g>
			<g>
	<g>
		<path class="st0" d="M24.2,0c-1.36,0-1.36,2.06,0,2.06C25.56,2.06,25.57,0,24.2,0z"/>
	</g>
</g>
</svg>
	</div>
</template>

<script>
    export default {
        name: "SolarCan4"
    }
</script>

<style scoped>
	.solarContainer{
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-template-rows: repeat(2, 1fr);
		grid-column-gap: 10px;
		grid-row-gap: 0px;
		margin: 5px;
	}

	.solarContainer > svg{
		display: block;
		margin: auto;
	}

	.icon1 {
		grid-area: 1 / 1 / 2 / 2;
		text-align: center;}
	.text1 {
		grid-area: 2 / 1 / 3 / 2;
		text-align: center;
	}
	.icon2 { grid-area: 1 / 2 / 2 / 3; }
	.text2 { grid-area: 2 / 2 / 3 / 3; text-align: center;}
	.icon3 { grid-area: 1 / 3 / 2 / 4; }
	.text3 { grid-area: 2 / 3 / 3 / 4; text-align: center; }
	.icon4 { grid-area: 1 / 4 / 2 / 5; }
	.text4 { grid-area: 2 / 4 / 3 / 5; text-align: center;}

	.st0{opacity:0.8;fill:#4D4D4D;}
</style>